const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'membership_password_setup_page',
    modelClass: require('./model'),
    viewClass: require('./view'),
    isEnabled() {
        return Odigeo.Membership.isMembershipPasswordSetupPage;
    },
    methods: {
        setTokenInfo(info) {
            this.model.updateTokenInfo(info);
        },
        track(data) {
            const {action, tag} = data;
            this.track(action, tag);
        },
    },
});
